import * as React from "react";
import PropTypes from "prop-types";
import { DefaultButton, PrimaryButton } from "@fluentui/react/lib/Button";
import { Persona, PersonaSize } from "@fluentui/react/lib/Persona";
import Layout from "./Layout";
import { useMeeting } from "./useMeeting";
import Error from "./Error";

const formatMeetingTime = (date) => {
  let result = "";

  const oneDayMilliSec = 24 * 60 * 60 * 1000;
  const oneWeekMilliSec = oneDayMilliSec * 7;

  const today = new Date();
  const timeDiff = date.getTime() - today.getTime();

  if (date.getTime() < Date.now() || timeDiff >= oneWeekMilliSec) {
    const sameYear = date.getFullYear() === new Date().getFullYear();
    result = `${date.toLocaleDateString([], {
      day: "numeric",
      month: "numeric",
      year: sameYear ? undefined : "numeric",
      hour: "2-digit",
      minute: "2-digit",
    })}`;
  } else if (timeDiff < oneDayMilliSec && date.getDate() === today.getDate()) {
    result = `Today ${date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    })}`;
  } else {
    result = `${date.toLocaleDateString([], {
      weekday: "long",
      hour: "2-digit",
      minute: "2-digit",
    })}`;
  }

  return result;
};

function NoMeetingContent({ onAddLink, loading }) {
  return (
    <div className="link__content">
      <PrimaryButton onClick={onAddLink} disabled={loading}>
        Add XMReality link
      </PrimaryButton>
      <p className="ms-fontSize-12 ms-fontColor-neutralSecondary ms-textAlignCenter">
        Set title and time in the meeting before adding the link
      </p>
    </div>
  );
}

function MeetingContent({ meeting, onRemoveLink, loading }) {
  return (
    <div className="link__content">
      <div className="link__content_detail ms-bgColor-white">
        <div className="link__content_detail_header ms-bgColor-themeLighter">{meeting.url}</div>
        <div>
          <div className="ms-fontSize-12 ms-fontColor-neutralTertiary">Title</div>
          <div>{meeting.title}</div>
        </div>
        <div>
          <div className="ms-fontSize-12 ms-fontColor-neutralTertiary">Time</div>
          <div>{formatMeetingTime(new Date(meeting.scheduledAt))}</div>
        </div>
        <div>
          <div className="ms-fontSize-12 ms-fontColor-neutralTertiary">XMReality description</div>
          <div>{meeting.description}</div>
        </div>
      </div>
      <DefaultButton onClick={onRemoveLink} disabled={loading}>
        Remove link
      </DefaultButton>
    </div>
  );
}

export default function SignedInView({ auth, setMessage, onSignOut, signOutError }) {
  const [loading, meeting, onAddMeetingLink, onRemoveMeetingLink] = useMeeting(setMessage);
  const header = (
    <div className="link__header">
      <Persona text={auth.user.name} hidePersonaDetails size={PersonaSize.size72} />
      <div className="ms-fontColor-neutralPrimary" style={{ marginTop: 16 }}>
        {auth.user.name}
      </div>
      <div className="ms-fontColor-neutralTertiary">{auth.user.email}</div>
    </div>
  );
  const content = meeting ? (
    <MeetingContent meeting={meeting} onRemoveLink={onRemoveMeetingLink} loading={loading} />
  ) : (
    <NoMeetingContent onAddLink={onAddMeetingLink} loading={loading} />
  );
  const footer =
    <>
      <Error error={signOutError} />
      <DefaultButton onClick={onSignOut}>Sign out</DefaultButton>
    </>
  return (
    <Layout header={header} content={content} footer={footer} />
  );
}

SignedInView.propTypes = {
  auth: PropTypes.object.isRequired,
  setMessage: PropTypes.func.isRequired,
  onSignOut: PropTypes.func.isRequired,
};
